import { createApp } from 'vue'
import EarthquakeCalculator from './EarthquakeCalculator.vue'
import './assets/global.css'

createApp(EarthquakeCalculator).mount('#earthquake')
